import $ from 'jquery';
import resetTotalAllocation from 'utils/total-allocation';
import './experian-intuitive-validation';
import '../../node_modules/jquery-validation/dist/additional-methods';

const IS_TRUE = 'true';
const IS_FALSE = 'false';

const formLabel = () => {
    const $label = $('.ktc-form-section-title');

    if ($label.length === 0) return;

    $label.each((i, title) => {
        if ($(title).first().parents('.ktc-default-section').prev().length > 0) {
            $(title).addClass('styled');
        }
    });
};

const formValidation = () => {
    const forms = $('form');

    if (forms.hasClass('form-layout')) return;
    forms.each(function () {
        const form = $(this);

        form.validate({
            // debug: true,
            ignore: ':hidden:not(.js-validate-hidden)',
            errorPlacement: (error, element) => {
                error.appendTo(element.parent());
                error.addClass('error-msg');
                // special for hidden input validation, it use inline custom error
                if (element.hasClass('js-validate-hidden')) {
                    error.appendTo(element.parents('.form-text'));
                }
            },
            highlight: (element, errorClass, validClass) => {
                const $el = $(element);
                $el.parents('.form-field').addClass('has-error');
                $el.addClass(errorClass).removeClass(validClass);
                $el.attr('disabled', false);

                // special for hidden input validation, it use inline custom error
                if ($el.hasClass('js-validate-hidden')) {
                    $el.parents('.form-text').addClass('has-error');
                }
            },
            unhighlight: (element, errorClass, validClass) => {
                const $el = $(element);
                $el.parents('.form-field').removeClass('has-error');
                $el.removeClass(errorClass).addClass(validClass);

                // special for hidden input validation, it use inline custom error
                if ($el.hasClass('js-validate-hidden')) {
                    $el.parents('.form-text').removeClass('has-error');
                }
            }
        });
    });
};

const resetFields = id => {
    if (!$(`input.${id}`).data('parent-checked')) {
        $(`input[type="text"].${id}, input[type="number"].${id}, select.${id}`).val('');
        $('.form-total-allocation').removeClass('has-error');
        resetTotalAllocation(id);
    }

    const $id = $(`[class*=${id}]`);

    // For the child that have children
    if ($id.find('input[type="radio"], input[type="checkbox"]').length > 0) {
        const $subChild = $(`[class*=${id}]`).find('input[type="radio"], input[type="checkbox"]');
        // Assuming that the option class will always comes second.
        const subChildClass = $subChild.attr('class').split(' ')[1].split('-')[0];
        const $subChildChildren = $(`.${subChildClass}`);
        if ($(`[data-toggle=${subChildClass}]`).data('parent-checked')) {
            $subChildChildren.addClass('is-hidden');
            if (!$subChildChildren.find('input').is(':checkbox')) {
                $subChildChildren.find('input, select').val('');
                $subChildChildren.find('input[type=radio]').prop('checked', false);

                if ($subChildChildren.find('label').hasClass('filled')) {
                    $subChildChildren.find('label').removeClass('filled');
                }
            }
        }
        $subChildChildren.parents('[data-parent-checked]').attr('data-parent-checked', false).addClass('is-hidden');
    }

    if ($id.find('label').hasClass('filled')) {
        $id.find('label').removeClass('filled');
    }

    // IF address field filled
    if ($id.find('.search-again-link').length > 0) {
        $id.find('.search-again-link')[0].click();
    }

    if ($id.find('input').is('input:text')) {
        $id.find('input').val(' ');
    }

    $(`input[type="radio"].${id}, input[type="checkbox"].${id}, input[type="checkbox"][data-toggle-group^=${id}]`)
        .prop('checked', false);
};

const equalToValidation = (id, $equalToEl) => {
    const equalData = 'data-rule-equalto';

    $equalToEl.attr(equalData, `#${id}`);
};

const requiredValidation = $elRequired => {
    // Set up the data attribute for validation
    const dataRule = 'data-rule-';
    const elName = $elRequired.attr('class').split(' ')[1];
    const equaltoClass = elName ? elName.split('-')[0] : false;

    if (!$(`.${equaltoClass}`).is('input[type="radio"]')) {
        $(`.${equaltoClass}`).attr(`${dataRule}${equaltoClass}`, true);
    }

    if (`${equaltoClass}-confirm` === elName) {
        const equalToId = $(`.${equaltoClass}`).attr('id');
        equalToValidation(equalToId, $(`.${elName}`));
    }
};

const phoneValidation = () => {
    const $mobileEl = $('[class*="mobilenumber"]');
    const AUPattern = '^(?:\\+?(61))? ?(?:\\((?=.*\\)))?(0?[2-57-8])\\)? ?(\\d\\d(?:[- ](?=\\d{3})|(?!\\d\\d[- ]?\\d[- ]))\\d\\d[- ]?\\d[- ]?\\d{3})$';

    $mobileEl.each((i, mobile) => {
        $(mobile).attr('pattern', AUPattern);
    });
};

const maxlengthValidation = () => {
    const $maxLengthEl = $('[class*="maxlength"], [data-toggle-val*="maxlength"]');
    $maxLengthEl.each((i, el) => {
        // Get maxlength
        let maxLengthClass = $(el).attr('class').split(' ')[1];

        if ($('[data-toggle-val*="maxlength"]').length > 0) {
            maxLengthClass = $(el).attr('data-toggle-val');
        }

        const maxlengthSet = maxLengthClass.split('maxlength')[1];

        $(el).removeAttr(`data-rule-${maxLengthClass}`);
        $(el).attr('maxlength', maxlengthSet);
    });

    $maxLengthEl.keyup(function () {
        const valueLength = $(this).val().length;
        const maxlength = parseInt($(this).attr('maxlength'), 10);

        if (valueLength > maxlength) {
            this.value = this.value.slice(0, maxlength);
        }
    });
};

const minlengthValidation = () => {
    const $minLengthEl = $('[class*="minlength"]');
    $minLengthEl.each((i, el) => {
        // Get minlength
        const minlengthSet = $(el).attr('class').split(' ')[1].split('minlength')[1];
        $(el).attr('minlength', minlengthSet);
    });
};

const dataToggle = ($toggleEl, value, parent, group) => {
    const dataToggleValue = 'data-toggle-val';
    const dataToggleParent = 'data-toggle';
    const dataToggleGroup = 'data-toggle-group';

    if ($toggleEl.is('[class$="opt"]')) {
        if (value !== undefined) $toggleEl.attr(dataToggleValue, value);
        if (group !== undefined && parent !== group) $toggleEl.attr(dataToggleGroup, group);

        $toggleEl.attr(dataToggleGroup, parent);
        $toggleEl.attr(dataToggleParent, parent);
    } else if (value === undefined) {
        $toggleEl.attr(dataToggleParent, parent);
    } else {
        $toggleEl
            .attr(dataToggleValue, value)
            .attr(dataToggleParent, parent);
    }
};

// Magick happens here...
const titleClassTransform = () => {
    const $title = $('[title]');

    if ($title.length === 0) return;

    $title.each((i, title) => {
        const $titleClass = $(title);
        const elTitle = $titleClass.attr('title');
        const lvlAttr = elTitle.split('|');
        const elAttr = lvlAttr[0].split(' ');
        const childLvl = lvlAttr.length - 1;
        const isRequired = elAttr[0] === 'required'; // Check if input value is required
        const isFormat = elAttr[0] === 'format'; // Check if input value need format checking
        const isMinLength = elAttr[0] === 'minlength'; // Check if input value need minlength checking
        const isScriptInjection = elAttr[0] === 'preventscript'; // Check if input value need script injection checking
        const isUrl = elAttr[0] === 'url'; // Check if input value need url checking

        const elClass = isRequired ? elAttr[1] : elAttr[0];
        const parent = lvlAttr.length > 1 ? $.trim(lvlAttr[childLvl]) : undefined;
        const optValue = isRequired ? elAttr[2] : elAttr[1];
        const group = elClass !== undefined ? elClass.split('-')[0] : undefined;

        if (isRequired) {
            $(title).addClass(elClass)
                .attr('required', true)
                .removeAttr('title');

            requiredValidation($titleClass);
        } if (isFormat || isMinLength || isScriptInjection || isUrl) {
            $titleClass.removeAttr('title').addClass(elClass);
            requiredValidation($titleClass);
        } else {
            $titleClass.removeAttr('title').addClass(elClass);
        }

        const value = optValue === '' ? undefined : optValue;
        dataToggle($titleClass, value, parent, group);
    });

    const $radioList = $('[class$="opt"]').parents('.ktc-radio-list');

    $radioList.each((id, list) => {
        const $radio = $(list).find('input[type="radio"]');

        $radio.each((r, radio) => {
            const radioData = $(radio).data('toggle');
            const radioValue = $(radio).val().toLocaleLowerCase().split('-')[0];
            $(radio).attr('data-toggle', `${radioData}-${r + 1}`);
            if (radioValue === IS_TRUE || radioValue === IS_FALSE) {
                const txtValue = $(radio).val().split('.');
                $(radio).val(txtValue[0]);
                $(radio).attr('data-text-value', txtValue.length > 1 ? txtValue[1] : radioValue);
            }
        });
    });
};

const initDropdownDependency = () => {
    const $selectCategory = $('select.category');
    $selectCategory.find('option').each((_, opt) => {
        const innerTxt = opt.value;
        if (innerTxt !== '') {
            const dependantValue = opt.innerHTML.split('|');
            $(opt).attr('data-dependency', dependantValue[0].trim());
            $(opt).text(innerTxt);
        }
    });
};

const initHideToggleGroup = $elementGroup => {
    const parentFields = '.form-row, .form-field, .form-element';
    $elementGroup.not('[class*="opt"]').each((i, el) => {
        if ($(el).data('toggle-val') !== undefined) {
            const $toggleParents = $(el).parents(`${parentFields}`);
            const radioGroup = $(el).attr('class');

            $toggleParents.addClass(`is-hidden ${radioGroup}`);
        }
    });

    $elementGroup.each((i, opt) => {
        if ($(opt).attr('type') === 'checkbox') {
            const $checkParents = $(opt).parents(`${parentFields}`);
            if ($(opt).attr('data-toggle-val')) {
                if ($(opt).is('[class*="opt"]')) {
                    const memberGroup = $(opt).attr('data-toggle');
                    $checkParents.addClass(`is-hidden ${memberGroup}`);
                }

                const checkOpt = $(opt).attr('class').split(' ')[1].split('-')[0];
                $(`[data-toggle=${checkOpt}]`)
                    .parents(`${parentFields}`).addClass(`is-hidden ${checkOpt}`);
            }
        }
    });
};

const hideToggleGroup = group => {
    $('[data-toggle-val="true"]').parents(`.${group}, [class*=' ${group}'], [class^='${group}']`).addClass('is-hidden');
    if ($(`#${group}`).length > 0) {
        $(`#${group}`).parents('.form-field').addClass('is-hidden');
    }

    resetFields(group);
};

const showToggleGroup = $groups => {
    const parentFields = '.form-row, .form-field, .form-element';
    const $toggleParents = $groups.parents(`${parentFields}`);
    $toggleParents.removeClass('is-hidden');
};

const showCheckGroup = ($check, value) => {
    const checkGroup = $check.attr('class').split(' ')[1].split('-')[0];
    const parentFields = '.form-row, .form-field, .form-element';
    $(`input[data-toggle=${checkGroup}][data-toggle-val=${value}]`)
        .parents(parentFields).removeClass('is-hidden');

    if ($(`.${checkGroup}-opt:checked`).length > 0) {
        if ($(`#${checkGroup}`).hasClass('has-error')) {
            $(`#${checkGroup}`).removeClass('has-error');
        }

        $(`#${checkGroup}`).parents(parentFields).removeClass('is-hidden');
    }
};

const hideCheckGroup = ($check, value) => {
    const checkGroup = $check.attr('class').split(' ')[1].split('-')[0];
    const parentFields = '.form-row, .form-field, .form-element';

    if (value === 'true') {
        $(`input[data-toggle=${checkGroup}][data-toggle-val=${value}]`)
            .parents(parentFields).addClass('is-hidden');
    } else {
        const $hideElements = $('div[data-parent-checked], a[data-parent-checked]');
        for (let i = 0; i < $hideElements.length; i += 1) {
            if (!$($hideElements[i]).attr('id')) {
                $($hideElements[i]).addClass('is-hidden');
            }
        }
    }

    if ($(`.${checkGroup}-opt:checked`).length < 1) {
        $(`#${checkGroup}`).parents(parentFields).addClass('is-hidden');
    }
};

const hideCategory = parentsClass => {
    $('.form-text.category').addClass('is-hidden');
    $('.form-text.category').parents(parentsClass).addClass('is-hidden');
    $('[data-toggle-group="category"]').parents(parentsClass).addClass('is-hidden');
    $('[data-toggle-group="category"]').each((_, radio) => {
        if ($(radio).is(':checked')) {
            $(radio).prop('checked', false);
        }
    });
};

const showCategory = value => {
    const parentsClass = '.form-field';
    const $categoryTextRadio = $(`[data-toggle=${value}], [data-toggle-val=${value}]`);
    const $parentCategoryGroup = $categoryTextRadio.parents(parentsClass);

    hideCategory(parentsClass);

    $(`.${value}`).removeClass('is-hidden');
    $parentCategoryGroup.removeClass('is-hidden');
};

const initHideCategoryGroup = $el => {
    $el.each((_, item) => {
        $(item).parents('.form-field').addClass('is-hidden');
    });
};

const createGroups = opts => {
    const group = [];

    $(opts).each((i, opt) => {
        if ($(opt).data('toggle') !== undefined) {
            const toggleField = $(opt).data('toggle-group') !== undefined ?
                $(opt).data('toggle-group') : $(opt).data('toggle');

            if ($.inArray(toggleField, group) === -1) {
                group.push(toggleField);
            }
        }
    });

    return group;
};

const toggleGroup = (groupName, value, index, toggle) => {
    const isNan = Number.isNaN(index);
    const $groups = $(`[data-toggle-val="true"][data-toggle=${groupName}-${index}]`);
    if (isNan) {
        // Stray child field
        const stringValue = value.toLowerCase();
        $('[data-toggle-val]').parents(`.${groupName}`).addClass('is-hidden');
        if ($(`.${groupName}`).find(`[data-toggle-val=${stringValue}][data-toggle=${toggle}]`).length > 0) {
            $(`[data-toggle-val=${stringValue}]`).parents(`.${groupName}`).removeClass('is-hidden');
        }
    } else if (value) {
        showToggleGroup($groups);
    } else {
        hideToggleGroup(groupName);
    }
};

const toggleCheckGroup = ($opts, value) => {
    $opts.each((i, opt) => {
        if ($(opt).data('toggle-val') !== undefined) {
            if ($(opt).is(':checked')) {
                showCheckGroup($(opt), value);
            } else {
                hideCheckGroup($(opt), value);
            }
        } else {
            const classOpt = $(opt).data('toggle');
            const hiddenClass = 'is-hidden';

            if ($(`.${classOpt}`).hasClass(hiddenClass)) {
                $(`.${classOpt}`).removeClass(hiddenClass);
            } else {
                $(`.${classOpt}`).addClass(hiddenClass);
            }
        }
    });
};

const fieldGroup = () => {
    const opts = 'input[class$="opt"]';
    const select = 'select.category';
    const groups = createGroups(opts);

    $.each(groups, (i, group) => {
        const $groupEl = $(`[data-toggle*=${group}]`);
        if ($groupEl) {
            initHideToggleGroup($groupEl, groups);
        }

        if (group === 'category') {
            $('.form-text.category').css('margin-bottom', 0);
            const $groupCat = $('div.category, [data-toggle-group="category"]');
            initHideCategoryGroup($groupCat);
        }
    });

    $(opts).on('click', e => {
        const $opt = $(e.currentTarget);
        let groupName = $opt.data('toggle-group') !== undefined ?
            $opt.data('toggle-group') : $opt.data('toggle');
        let inputValue =
            $opt.val().split('-')[1] ? JSON.parse($opt.val().split('-')[0].toLowerCase()) : $opt.val();
        const inputIdx = parseInt($opt.val().substr($opt.val().length - 1), 10);

        if ($opt.attr('type') === 'radio') {
            const fieldToggle = $opt.attr('data-toggle');
            groupName = $opt.attr('data-toggle-group');
            toggleGroup(groupName, inputValue, inputIdx, fieldToggle);
        } else {
            inputValue = $opt.data('val');
            toggleCheckGroup($opt, inputValue.toString());
        }
    });

    $(select).on('change', e => {
        const $target = $(e.target);
        if ($target.hasClass('category')) {
            const optValue = $target.find(':selected').attr('data-dependency');
            showCategory(optValue);
        }
    });
};

const addressSuggestion = () => {
    const $address = $('[class*="-address-search"]');
    if ($address.length === 0) return;

    $address.each(function () {
        const $el = $(this);
        const $addressRow = $el.parents().next('.form-row');
        const getAddrClass = $el.attr('class').split(' ')[1];
        const lastIndex = getAddrClass !== undefined ? getAddrClass.lastIndexOf('-') : 0;
        const addressClass = getAddrClass !== undefined ? getAddrClass.substring(0, lastIndex) : '';
        const options = {
            token: 'eee6e586-7bd9-4f6b-8fbb-d1bbdd89ba88',
            useSpinner: true,
            searchAgain: { location: this },
            submmitAddress: 'Use address entered',
            useAddressEnteredText: 'Use address entered',
            elements: {
                addressLine1: this,
                addressLine2: this,
                addressLine3: this,
                locality: $addressRow.find(`.${addressClass}-suburb`)[0] || $('<div class="not-exist hidden"></div>'),
                province: $addressRow.find(`.${addressClass}-state`)[0] || $('<div class="not-exist hidden"></div>'),
                postalCode: $addressRow.find(`.${addressClass}-postcode`)[0] || $('<div class="not-exist hidden"></div>'),
                input: this,
                countryList: $('<input value="AUS" />')[0]
            }
        };

        /* eslint-disable-next-line */
        var address = new ContactDataServices.address(options);
    }).parent('.editing-form-control-nested-control').addClass('validation-experian-qas');
};

const submitForm = () => {
    $('input[type="submit"]').click(e => {
        const $form = $(e.target).parents('form');

        formValidation();

        if (!$form.valid()) {
            e.preventDefault();

            const fieldErrorTop = $($form.find('.has-error')[0]).position().top - 10;
            $('html, body').animate({ scrollTop: fieldErrorTop }, 'slow');
        }
    });
};

const tfnOptionStyle = () => {
    const $tfn = $('.tfn');

    if ($tfn.length === 0) return;

    $tfn.parents('.ktc-radio-list').addClass('margin-top');
};

const tooltip = () => {
    const $tooltip = $('.explanation-text');

    if ($tooltip.length === 0) return;

    $tooltip.each((i, e) => {
        $(e).addClass('tooltip');
    });

    const $toolTrigger = $tooltip.siblings('.control-label').find('span');
    const $toolTriggerText = $tooltip.siblings('.tooltip');
    let tooltipTextLeft = '';

    if ($toolTriggerText.length > 0) {
        tooltipTextLeft = $toolTriggerText.offset().left;
    }

    const tooltipPosition = () => {
        if ($(window).width() < 768) {
            if (tooltipTextLeft < ($(window).width() / 2)) {
                $toolTriggerText.siblings('.explanation-text').addClass('right');
            }
        } else {
            $toolTriggerText.siblings('.explanation-text').removeClass('right');
        }
    };

    tooltipPosition();

    $(window).on('resize', () => {
        tooltipPosition();
    });

    $toolTrigger.hover(e => {
        $(e.target).parent().siblings('.explanation-text').addClass('show');
    }, e => {
        $(e.target).parent().siblings('.explanation-text').removeClass('show');
    });

    $toolTriggerText.hover(e => {
        $(e.target).siblings('.explanation-text').addClass('show');
    }, e => {
        $(e.target).siblings('.explanation-text').removeClass('show');
    });
};

const checkboxValueHelper = () => {
    const $checkboxValue = $('.ktc-checkbox').parent().siblings('.explanation-text');

    if ($checkboxValue.length === 0) return;

    $checkboxValue.each((i, chck) => {
        const $inputChk = $(chck);
        const chckValue = $inputChk.text();

        $inputChk.parents('.form-field').find('input[type="checkbox"]').attr('data-val', chckValue);
    });
};

const tfnInputMask = () => {
    // apply auto input-mask on your-tfn text field
    const yourTFN = document.querySelector('input[data-rule-tfn="true"]');

    if (yourTFN) {
        $(yourTFN).attr('inputmode', 'numeric');
        let timeoutYourTFN = null;
        const delayTimeoutYourTFN = 100;
        yourTFN.addEventListener('keyup', () => {
            yourTFN.value = yourTFN.value.trim();
            clearTimeout(timeoutYourTFN);
            timeoutYourTFN = setTimeout(() => {
                if (yourTFN.value.length === 9) {
                    yourTFN.value = yourTFN.value.replace(/ /g, '');
                    const number = yourTFN.value;
                    yourTFN.value = number.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                    yourTFN.blur();
                    yourTFN.focus();
                }
            }, delayTimeoutYourTFN);
        }, false);
    }
};

const promoInputMask = () => {
    // apply auto input-mask on promo code text field
    const promoCode = document.querySelector('input[data-rule-format="true"]');

    if (promoCode) {
        promoCode.addEventListener('input', e => {
            e.target.value = e.target.value.replace(/[^a-z0-9A-Z]/g, '');
        });
    }
};

const autoFocus = () => {
    const $autoFocusElement = $('[data-toggle*="autofocus"]');

    if ($autoFocusElement) {
        $autoFocusElement.on('input', e => {
            const $this = $(e.currentTarget);

            if ($this.val() !== '') {
                $this.val($this.val().replace(/[^0-9.]/g, ''));
                if ((e.which !== 46 || $this.val().indexOf('.') !== -1) && (e.which < 48 || e.which > 57)) {
                    e.preventDefault();
                }
            }
        });

        $autoFocusElement.keyup(function () {
            const parentClasses = '.form-wrapper';
            const $inputLabel = $(this).parents(parentClasses)
                .siblings()
                .find('.control-label');
            const idx = $(this).attr('data-toggle').split('-')[1];

            if (this.value.length === this.maxLength) {
                $($autoFocusElement[idx]).focus();
                if (parseInt(idx, 4) === $autoFocusElement.length) {
                    $inputLabel.addClass('filled');
                } else {
                    $inputLabel.removeClass('filled');
                }
            } else {
                $inputLabel.removeClass('filled');
            }
        });
    }
};

const inputLabelValidation = () => {
    const $input = $('input, select');
    const parentClasses = '.form-field';

    $input.keyup(function () {
        const $inputLabel = $(this).parents(parentClasses).find('.control-label');
        if ($(this).val() !== '') {
            if (!$inputLabel.hasClass('dob')) {
                $inputLabel.addClass('filled');
            }
        } else {
            $inputLabel.removeClass('filled');
        }
    });

    $input.change(function () {
        const $inputLabel = $(this).parents(parentClasses).find('.control-label');
        const toggleLabel = $(this).attr('data-toggle-group');
        const $prevEl = $(`.${toggleLabel}`).find('.control-label');

        if (this.checked) {
            if ($(this).attr('type') === 'checkbox') {
                $prevEl.addClass('filled');
            } else {
                $inputLabel.addClass('filled');
            }
        }

        if ($(`[class*="-checkbox"][data-toggle="${toggleLabel}"]`)
            .find('input:checked').length < 1) {
            $prevEl.removeClass('filled');
        }

        if ($(this).is('select') && $(this).parents('.form-row')
            .attr('class') !== undefined) {
            const classGroup = $(this).parents('.form-row')
                .attr('class').split(' ')
                .pop();
            const $prevRowLabel = $(this).parents('.form-row').prev(`.${classGroup}`);

            if ($(this).find('option:selected').val() !== '') {
                $inputLabel.addClass('filled');
            } else {
                $inputLabel.removeClass('filled');
            }

            if ($(this).find('option:selected').val() !== '' && $prevRowLabel) {
                $prevRowLabel.find('label').addClass('filled');
            } else {
                $prevRowLabel.find('label').removeClass('filled');
            }
        }

        const nameAttr = $(this).attr('name');
        if (nameAttr === undefined) return;

        if ($(this).attr('name').indexOf('toggle') < 0) {
            if ($(this).attr('class').split(' ')[1] !== undefined) {
                const addressGroup = $(this).attr('class').split(' ')[1].replace('-search', '');

                if ($(this).attr('class').split(' ')[1].indexOf('search') > -1) {
                    $(`[class*=${addressGroup}]`).each(function () {
                        $(this).parents(parentClasses).find('.control-label').addClass('filled');
                    });
                }
            }
        }
    });

    $input.on('focus blur', function () {
        if ($(this).val() === '') {
            $(this).parents(parentClasses).find('.control-label').removeClass('filled');
        }
    });
};

const preventPaste = () => {
    if ($('.email-confirm').length > 0) {
        $('.email-confirm').each((i, e) => {
            $(e).bind('copy paste', event => {
                event.preventDefault();
            });
        });
    }
};

const inputMode = () => {
    const $inputs = $('[data-toggle-val="number"], [class*="number"], [class*="postcode"], input[type="email"], [data-toggle="autofilldisable"]');

    if ($inputs.length) {
        $inputs.each((i, e) => {
            if ($(e).attr('type') === 'email') {
                $(e).attr('inputmode', 'email');

                if ($(e).attr('data-toggle')
                    && $(e).attr('data-toggle') === 'autofilldisable') {
                    $(e).attr('autocomplete', 'none');
                }
            } else {
                $(e).attr('inputmode', 'numeric');
            }
        });

        $('[class*="mobilenumber"]').each((i, tel) => {
            $(tel).attr('inputmode', 'tel');
        });
    }
};

const wrappedColumns = () => {
    const $columns = $('[data-toggle-val="column"]');
    const $wrapper = $('<div class="form-wrapper"></div>');
    const parentClasses = '.form-field';

    if ($columns.length) {
        const $columnWrapper = $columns.parents(parentClasses).parent();
        $columnWrapper.find('.form-field').slice(1).wrapAll($wrapper);
    }
};

$(() => {
    titleClassTransform();
    tfnOptionStyle();
    initDropdownDependency();
    fieldGroup();
    addressSuggestion();
    formLabel();
    phoneValidation();
    maxlengthValidation();
    minlengthValidation();
    submitForm();
    tooltip();
    checkboxValueHelper();
    tfnInputMask();
    promoInputMask();
    autoFocus();
    inputLabelValidation();
    preventPaste();
    inputMode();
    wrappedColumns();
});
